{
  "acsSlow": {
    "body": "Ti stiamo mettendo in contatto con il gestore del tuo metodo di pagamento per autorizzare la transazione.",
    "title": "In attesa di risposta dalla tua banca…"
  },
  "app": {
    "title": "Paga un avviso - pagoPA"
  },
  "ariaLabels": {
    "appLanguage": "Imposta lingua",
    "close": "Chiudi",
    "editCard": "Modifica dati carta",
    "editDonation": "Modifica ente donazione",
    "editPsp": "Modifica PSP",
    "informationDialog": "Informazioni sul costo di commissione",
    "informationLink": "Per saperne di più sulla campagna di",
    "languageMenu": "Lingua impostata",
    "loading": "Caricamento",
    "applySorting": "Applica l’ordine selezionato",
    "sortingDefault": "Ordinamento Predefinito",
    "sortingName": "Ordinamento Per nome",
    "sortingAmount": "Ordinamento Per importo"
  },
  "cancelledPage": {
    "body": "L'operazione è stata annullata",
    "button": "Chiudi"
  },
  "authCallbackPage": {
    "title": "Non è stato possibile accedere",
    "body": "Si è verificato un problema durante l'accesso. Riprova tra qualche minuto.",
    "buttons": {
      "retry": "Riprova",
      "continueWithoutLogin": "Continua senza login"
    }
  },
  "authExpiredPage": {
    "title": "La tua sessione è scaduta",
    "body": "Accedi per riprendere la sessione, oppure prosegui senza effettuare il login ",
    "buttons": {
      "login": "Accedi",
      "continueWithoutLogin": "Continua senza login."
    }
  },
  "cartDetail": {
    "amount": "Importo",
    "companyName": "Ente Creditore",
    "description": "Oggetto del pagamento",
    "fiscalCode": "Codice Fiscale Ente Creditore",
    "iuv": "IUV",
    "noticeNumber": "Codice Avviso"
  },
  "clipboard": {
    "copied": "Copiato",
    "copy": "Copia",
    "edit": "Modifica"
  },
  "DOMAIN_UNKNOWN": {
    "title": "L’Ente Creditore sta avendo problemi nella risposta",
    "buttons": {
      "close": "Chiudi",
      "help": "Contatta l’assistenza"
    }
  },
  "DONATIONLIST_ERROR": "Non siamo riusciti a caricare la lista delle organizzazioni.",
  "donationPage": {
    "click": "premi",
    "code": "e inquadra il codice:",
    "description": "Hai tempo fino al 23 dicembre. Puoi donare con carta senza costi di commissione. L’importo verrà versato direttamente sul conto dell’organizzazione a cui scegli di donare.",
    "dismissCTA": "Vedi le organizzazioni",
    "dismissDescription": "Se vuoi puoi donare a una delle organizzazioni umanitarie che avevano aderito all’iniziativa.",
    "dismissTitle": "Il servizio non è più attivo",
    "entity": "A chi vuoi donare?",
    "ioDescription": "Dona con l’app IO per ricevere un’e-mail con i dati utili ai fini delle agevolazioni fiscali.",
    "modalBody2": "Puoi donare senza costi di commissione con le tue carte.",
    "modalTitle": "Continua sull'app IO",
    "openSection": "Apri la sezione",
    "payNotice": "Paga un avviso",
    "portfolio": "Portafoglio",
    "submitCard": "Dona con carta",
    "submitIO": "Dona con IO",
    "title": "Dona per la crisi in Ucraina",
    "volunteer": "Quanto vuoi donare?"
  },
  "errorButton": {
    "close": "Chiudi",
    "help": "Contatta l'assistenza",
    "retry": "Riprova"
  },
  "ErrorCodeDescription": "Codice di errore per l'assistenza",
  "GENERIC_ERROR": {
    "body": "Riprova, oppure contatta l’assistenza.",
    "title": "Si è verificato un errore imprevisto"
  },
  "general": {
    "and": "e"
  },
  "indexPage": {
    "description": "Puoi pagare con carta, conto e app di pagamento. Riceverai l'esito via email.",
    "title": "Paga un avviso"
  },
  "iframeCardPage": {
    "helpLink": "Dove trovo il CVV?",
    "modalTitle": "Dove trovo il CVV?",
    "modalBodyText": "Il codice CVV (o CVC) ha 3 cifre e lo trovi sul retro della tua carta.<br>Sulle carte American Express, il codice (CID) ha 4 cifre ed è posizionato sul fronte.",
    "buttonClose": "Chiudi"
  },
  "inputCardPage": {
    "formErrors": {
      "cid": "Inserisci 4 cifre",
      "cvv": "Inserisci 3 cifre",
      "expirationDate": "Inserisci mm/aa",
      "name": "Inserisci come riportato sulla carta",
      "number": "Inserisci un numero valido",
      "required": "Campo obbligatorio"
    },
    "formFields": {
      "cid": "CID (4 cifre)",
      "cvv": "CVV",
      "expirationDate": "Scadenza",
      "name": "Intestata a",
      "number": "Numero carta",
      "required": "Campo obbligatorio"
    },
    "helpLink": "Dove trovo il codice di sicurezza?",
    "modal": {
      "description": "È un codice a tre cifre, chiamato CVV o CVS, che puoi trovare sul retro della tua carta.",
      "descriptionAE": "Sulle carte American Express il codice (CID) è a quattro cifre ed è posizionato sul fronte.",
      "title": "Codice di sicurezza"
    },
    "title": "Inserisci i dati della carta"
  },
  "INVALID_CARD": {
    "body": "Prova ad inserire una carta valida o eventualmente contattaci per ricevere assistenza.",
    "title": "Spiacenti, la carta è risultata non valida"
  },
  "INVALID_DECODE": {
    "body": "Prova di nuovo o contattaci per ricevere assistenza.",
    "title": "Si è verificato un errore nella lettura dei dati"
  },
  "INVALID_QRCODE": {
    "body": "Se il problema persiste, prova a inserire i dati manualmente.",
    "title": "Il codice inquadrato non è un avviso pagoPA"
  },
  "koPage": {
    "body": "Non è stato addebitato alcun importo.",
    "button": "Chiudi",
    "helpButton": "Serve aiuto?",
    "learnMoreButton": "Scopri di più",
    "title": "Si è verificato un errore imprevisto"
  },
  "mainPage": {
    "footer": {
      "accessibility": "Accessibilità",
      "help": "Aiuto",
      "privacy": "Privacy",
      "terms": "Condizioni",
      "platformStatus": "Stato della piattaforma",
      "pagoPA": "Visita il sito pagoPA"
    },
    "header": {
      "login": "Accedi",
      "logout": "Esci",
      "detail": {
        "detailButton": "Apri riepilogo pagamento",
        "detailFC": "Codice Fiscale Ente Creditore",
        "detailIUV": "Codice IUV",
        "detailAmount": "Totale parziale",
        "detailReceiver": "Ente Creditore",
        "detailSubject": "Oggetto del pagamento",
        "detailTitle": "Dettaglio avviso"
      },
      "disclaimer": "L’importo è aggiornato in automatico, così paghi sempre quanto dovuto ed eviti more o altri interessi."
    },
    "main": {
      "skipToContent": "Vai al contenuto principale"
    }
  },
  "NOTLISTED": {
    "body": "Prova di nuovo o contattaci per ricevere assistenza.",
    "title": "Si è verificato un errore imprevisto"
  },
  "PAYMENT_CANCELED": {
    "body": "Contatta l’Ente per maggiori informazioni.",
    "title": "L’Ente Creditore ha revocato questo avviso"
  },
  "PAYMENT_DATA_ERROR": {
    "title": "I dati dell'avviso non sono corretti"
  },
  "PAYMENT_DUPLICATED": {
    "body": "Se hai pagato su questo sito, la conferma è stata inviata all'indirizzo email che hai indicato durante il pagamento.",
    "title": "Questo avviso è stato già pagato!"
  },
  "PAYMENT_EXPIRED": {
    "body": "Contatta l’Ente per maggiori informazioni.",
    "title": "L’avviso è scaduto e non è più possibile pagarlo"
  },
  "PAYMENT_ONGOING": {
    "body": "Se il problema persiste, segnalacelo!",
    "title": "C’è già un pagamento in corso, riprova più tardi"
  },
  "PAYMENT_UNAVAILABLE": {
    "title": "C’è un problema tecnico con questo avviso"
  },
  "PAYMENT_UNKNOWN": {
    "body": "L'avviso potrebbe essere stato già pagato. Per ricevere assistenza, contatta l’Ente Creditore.",
    "title": "Non riusciamo a trovare l’avviso"
  },
  "pspUnavailable": {
    "body": "Può succedere quando l’importo da pagare è particolarmente elevato, o se stai cercando di pagare una marca da bollo digitale.",
    "cta": {
      "primary": "Scegli un altro metodo"
    },
    "title": "Il metodo di pagamento selezionato non è disponibile"
  },
  "paymentEmailPage": {
    "description": "Riceverai l’esito del pagamento a questo indirizzo",
    "formButtons": {
      "back": "Indietro",
      "submit": "Continua"
    },
    "formErrors": {
      "invalid": "Inserisci un indirizzo email valido",
      "notEqual": "Gli indirizzi email non coincidono",
      "required": "Campo obbligatorio"
    },
    "formFields": {
      "confirmEmail": "Ripeti di nuovo",
      "email": "Indirizzo email"
    },
    "title": "Inserisci la tua email"
  },
  "findOutMoreModal": {
    "title": "Cosa fare se il pagamento non va a buon fine?",
    "section1Title": "1. Paga l'avviso",
    "section1ContentRow1": "Ricorda di pagare l'avviso entro le scadenze previste dall'ente.",
    "section1ContentRow2": "Se non riesci tramite questo sito, ",
    "section1ContentRow2Link": "scopri gli altri canali abilitati a pagoPA.",
    "section2Title": "2. Attendi il rimborso",
    "section2ContentRow1": "Di solito l'importo viene riaccreditato entro pochi minuti.",
    "section2ContentRow2": "In altri casi, il trasferimento di denaro sul tuo conto o carta potrebbe richiedere più tempo.",
    "section3Title": "3. Contatta l'assistenza",
    "section3ContentRow1": "Se dopo 5 giorni lavorativi non hai ancora ricevuto il rimborso, ",
    "section3ContentRow2Link": "contatta l'assistenza."
  },
  "paymentResponsePage": {
    "0": {
      "body": "Abbiamo inviato la conferma del pagamento a {{useremail}}",
      "title": "Hai pagato {{amount}}"
    },
    "1": {
      "body": "Non è stato addebitato alcun importo.",
      "title": "Si è verificato un errore imprevisto."
    },
    "2": {
      "body": "Non è stato addebitato alcun importo. Controlla di aver seguito correttamente le istruzioni della tua banca.",
      "title": "Autorizzazione negata"
    },
    "3": {
      "body": "Se hai pagato con una carta di debito o credito, assicurati di inserire i dati come riportato sul fronte.",
      "title": "I dati del metodo di pagamento non sono corretti"
    },
    "4": {
      "body": "Non è stato addebitato alcun importo. Per la tua sicurezza, hai a disposizione un tempo limitato per completare l’operazione.",
      "title": "La sessione è scaduta"
    },
    "5": {
      "title": "Il circuito della carta non è supportato"
    },
    "6": {
      "title": "Mancano alcuni dati per procedere con il pagamento"
    },
    "7": {
      "body": "Per maggiori informazioni, contatta la tua banca.",
      "title": "Il metodo di pagamento è scaduto o non più valido"
    },
    "8": {
      "body": "Non è stato addebitato alcun importo.",
      "title": "L’operazione è stata annullata"
    },
    "10": {
      "body": "Non è stato addebitato alcun importo. Probabilmente hai superato i limiti di spesa previsti dalla tua banca.",
      "title": "Autorizzazione negata"
    },
    "12": {
      "title": "Il metodo di pagamento non è supportato"
    },
    "17": {
      "body": "Il pagamento non si è ancora concluso: se non ricevi l'esito positivo entro 15 minuti all'indirizzo {{useremail}} riprova di nuovo.",
      "title": "Attendi la conferma del pagamento"
    },
    "18": {
      "body": "L’importo autorizzato è stato rimborsato sul tuo metodo di pagamento. Il trasferimento di denaro potrebbe richiedere del tempo.",
      "title": "Il pagamento non è andato a buon fine"
    },
    "25": {
      "body": "Non è stato addebitato alcun importo.\n Se il problema persiste, prova a usare un altro metodo o gestore del pagamento.",
      "title": "Il pagamento non è andato a buon fine"
    },
    "116": {
      "body": "Non è stato addebitato alcun importo. Prima di riprovare, aggiungi fondi alla carta o usa un altro metodo di pagamento.",
      "title": "Il saldo della tua carta è insufficiente"
    },
    "117": {
      "body": "Non è stato addebitato alcun importo. Il codice (CVV o CVC) ha 3 cifre ed è riportato sul retro della carta. Se usi American Express, il codice (CID) ha 4 cifre ed è sul fronte.",
      "title": "Il codice di sicurezza inserito è errato"
    },
    "121": {
      "body": "Non è stato addebitato alcun importo. Prima di riprovare, modifica il limite di spesa o usa un altro metodo di pagamento.",
      "title": "Hai superato il limite di spesa della tua carta"
    },
    "3dsNotInitiated": {
      "body": "Non è stato addebitato alcun importo.\nSe il problema persiste, contatta il gestore del metodo di pagamento, per esempio la tua banca.",
      "title": "C’è stato un problema con il gestore del tuo metodo di pagamento"
    },
    "buttons": {
      "continue": "Continua",
      "findOutMode": "Scopri di più"
    },
    "survey": {
      "body": "Raccontaci la tua esperienza con il pagamento e aiutaci a migliorare.",
      "link": {
        "href": "https://pagopa.qualtrics.com/jfe/form/SV_0jllXJcXhmSpb38",
        "text": "Vai al sondaggio"
      },
      "title": "Puoi dirci com’è andata?"
    }
  },
  "paymentCheckPage": {
    "buttons": {
      "cancel": "Annulla",
      "submit": "Paga",
      "wait": "Attendi…"
    },
    "creditCard": "Paga con",
    "disclaimer": {
      "cheaper": "Suggerito perché il più economico",
      "yourCard": "Suggerito perché sei già cliente",
      "psp": "Proseguendo accetti i <terms>Termini e condizioni d'uso</terms> e dichiari di aver letto l'<privacy>Informativa Privacy</privacy> di <psp>{{pspName}}</psp>"
    },
    "drawer": {
      "body": "In questa lista trovi tutti i gestori compatibili con il tuo metodo, anche se non sei loro cliente.",
      "header": {
        "amount": "Commissione",
        "name": "Gestore"
      },
      "title": "Con quale gestore vuoi pagare?",
      "pspNameAccessibilityLabel": "Ordina in ordine alfabetico per nome del gestore",
      "taxFeeAccessibilityLabel": "Ordina dall'importo di commissione più basso",
      "selectPspAccessibilityLabel": "Seleziona {{pspName}} come gestore di pagamento"
    },
    "email": "Invia esito a:",
    "modal": {
      "body": "Qualsiasi operazione di trasferimento di denaro (in contanti o in moneta elettronica) ha un costo, che serve a garantirti che quel pagamento sia sicuro e arrivi a buon fine.\nOgni gestore (o PSP, Prestatore di Servizi di Pagamento) propone un costo, a seconda delle proprie politiche commerciali e condizioni contrattuali.\nCon pagoPA, questi costi sono trasparenti e il cittadino può scegliere liberamente l'opzione più comoda e conveniente. Per saperne di più, consulta la pagina ",
      "cancelBody": "Se esci, tutti i dati inseriti fino ad ora verranno cancellati e dovrai ricominciare da capo",
      "cancelButton": "No, ho cambiato idea",
      "cancelTitle": "Il tuo pagamento è in corso, vuoi davvero uscire?",
      "link": "Trasparenza Costi",
      "submitButton": "Esci",
      "title": "Perché c'è un costo di commissione?"
    },
    "psp": "Applicata da",
    "total": "Totale",
    "transaction": "Commissione"
  },
  "paymentChoicePage": {
    "saved": "Salvati",
    "bank": "Conto corrente",
    "button": "Indietro",
    "costs": "Trasparenza Costi.",
    "creditCard": "Carta di debito o credito",
    "description": "Per saperne di più sui metodi e i costi applicati dai gestori aderenti, visita la pagina ",
    "incoming": "In arrivo",
    "others": "Altri metodi",
    "showMore": "Metodi non disponibili",
    "title": "Come vuoi pagare?",
    "filterLabel": "Cerca un metodo",
    "feeRange": "Commissione: da {{min}}  a {{max}}",
    "feeSingle": "Commissione: {{value}}",
    "noPaymentMethodsAvailable": "Nessun risultato trovato. Prova con un altro termine.",
    "filterButton": "Filtra",
    "drawer": {
      "title": "Filtra Metodi",
      "byType": "Per tipo",
      "byFunc": "Per funzionalità",
      "card": "Carta",
      "balance": "Conto Corrente",
      "appApm": "App e altri metodi",
      "payByPlan": "Pagamento a rate",
      "showResults": "Mostra risultati",
      "remove": "Cancella tutti i filtri"
    }
  },
  "paymentMethods": {
    "bpay": "BANCOMAT Pay",
    "cc": "Conto corrente",
    "cp": "Carta di debito o credito",
    "ppay": "Paga con Postepay"
  },
  "paymentNoticeChoice": {
    "form": {
      "description": "Codice Avviso e Codice Fiscale Ente",
      "title": "Inserisci tu i dati"
    },
    "qr": {
      "description": "Usa la tua webcam o fotocamera",
      "title": "Inquadra il codice QR"
    }
  },
  "paymentNoticePage": {
    "description": "Inserisci i dati come riportato sull’avviso di pagamento.",
    "exampleModalAltText": "Avviso di pagamento pagoPA, con evidenziata la parte in cui sono presenti il codice avviso e il codice fiscale dell’ente creditore",
    "exampleModalTitle": "Esempio di avviso pagoPA",
    "formButtons": {
      "cancel": "Indietro",
      "submit": "Continua"
    },
    "formErrors": {
      "minCf": "Inserisci 11 cifre",
      "minCode": "Inserisci 18 cifre",
      "required": "Campo obbligatorio"
    },
    "formFields": {
      "billCode": "Codice Avviso",
      "cf": "Codice Fiscale Ente Creditore"
    },
    "helpLink": "Vedi un esempio",
    "title": "Cosa devi pagare?"
  },
  "paymentPspListPage": {
    "title": "Scegli chi gestirà il pagamento",
    "description": "Ogni gestore propone una commissione. In questa lista trovi tutti i gestori compatibili, <strong>anche se non sei loro cliente</strong>.",
    "operator": "Gestore",
    "alreadyClient": "Sei già cliente",
    "formButtons": {
      "back": "Indietro",
      "submit": "Continua"
    },
    "sort": "Ordina",
    "drawer": {
      "sorting": {
        "default": "Predefinito",
        "name": "Per nome",
        "amount": "Per importo"
      },
      "showResults": "Applica"
    },
    "myBankAlertTitle": "Non trovi la tua banca?",
    "myBankAlertBody": "Non preoccuparti: dovrai selezionarla nei passaggi successivi."
  },
  "paymentQrPage": {
    "camBlocked": "Abbiamo bisogno del tuo consenso per utilizzare la fotocamera. Per modificare la tua scelta, visita le impostazioni Privacy del tuo browser",
    "description": "Assicurati di avere una buona illuminazione. Se il codice non è a fuoco, prova ad allontanarlo leggermente dallo schermo.",
    "navigate": "Non funziona? Inserisci manualmente",
    "reloadPage": "Ricarica la pagina",
    "title": "Inquadra il codice QR",
    "usageHintPc": "Questa pagina richiede l'uso del lettore di codici QR. Per scansionare il codice QR, consenti al browser l'accesso alla fotocamera quando richiesto. Potresti dover utilizzare una webcam esterna o integrata. Il codice QR deve essere ben inquadrato e ben illuminato per facilitarne la lettura.",
    "usageHintMobile": "Questa pagina richiede l'uso del lettore di codici QR. Per scansionare il codice QR, consenti al browser l'accesso alla fotocamera quando richiesto. Utilizza la fotocamera posteriore del tuo smartphone e orientala verso il codice QR. Il codice QR deve essere ben inquadrato e ben illuminato per facilitarne la lettura."
  },
  "paymentSummaryPage": {
    "amount": "Importo aggiornato",
    "billCode": "Codice Avviso",
    "buttons": {
      "cancel": "Indietro",
      "ok": "Ok, va bene",
      "submit": "Vai al pagamento"
    },
    "causal": "Oggetto del pagamento",
    "cf": "Codice Fiscale Ente Creditore",
    "creditor": "Ente Creditore",
    "description": "Quando l'importo cambia, significa che è stato aggiornato automaticamente. Se è più alto, potrebbero esserci interessi, sanzioni o costi di notifica.\n\nSe l'avviso pagoPA riguarda una comunicazione a valore legale, l'aumento dell'importo da pagare può dipendere da diversi fattori, per esempio:\n• se hai ricevuto la comunicazione tramite raccomandata (i cui costi di stampa e invio possono essere a carico del destinatario);\n• il numero di tentativi di recapito.\n\nPer ulteriori dettagli contatta l'ente creditore.",
    "dialog": {
      "description": "Quando l'importo cambia, significa che è stato aggiornato automaticamente. Se è più alto, potrebbero esserci interessi, sanzioni o costi di notifica.\n\nSe l'avviso pagoPA riguarda una comunicazione a valore legale, l'aumento dell'importo da pagare può dipendere da diversi fattori, per esempio:\n• se hai ricevuto la comunicazione tramite raccomandata (i cui costi di stampa e invio possono essere a carico del destinatario);\n• il numero di tentativi di recapito.\n\nPer ulteriori dettagli contatta l'ente creditore.",
      "title": "L'importo è diverso da quello riportato sull'avviso pagoPA?"
    },
    "iuv": "Codice IUV",
    "title": "Dati del pagamento"
  },
  "POLLING_SLOW": {
    "body": "Ti preghiamo di attendere un paio di minuti al massimo senza ricaricare la pagina nel frattempo.",
    "title": "L’Ente sta impiegando più tempo del previsto..."
  },
  "privacyInfo": {
    "googleDesc": "Form protetto tramite reCAPTCHA e Google.",
    "privacyDesc": "Proseguendo accetti i <terms>Termini e condizioni d'uso</terms> del servizio e confermi di aver letto l'<privacy>Informativa Privacy</privacy>",
    "privacyDonation": "Termini aggiuntivi del servizio Donazioni a favore dell’emergenza in Ucraina"
  },
  "STATUS_ERROR": {
    "body": "Se il problema persiste, segnalacelo!",
    "title": "Si è verificato un errore imprevisto"
  },
  "TIMEOUT": {
    "body": "Se il problema persiste, segnalacelo!",
    "title": "L'Ente Creditore sta avendo problemi nella risposta"
  },
  "errorMessageNPG": {
    "HF0001": "Inserisci 3 o 4 cifre",
    "HF0002": "Servizio temporaneamente non disponibile",
    "HF0003": "La sessione è scaduta, torna indietro e riprova",
    "HF0004": "Inserisci un numero valido",
    "HF0005": "Il circuito di questa carta non è supportato",
    "HF0006": "Inserisci mm/aa",
    "HF0007": "Inserisci come riportato sulla carta",
    "HF0009": "Verifica 3DS fallita"
  },
  "userSession": {
    "logoutModal": {
      "title": "Vuoi davvero uscire?",
      "body": "Potrai comunque pagare anche senza accedere.",
      "submitButton": "Esci",
      "cancelButton": "Annulla"
    }
  },
  "ScheduledMaintenanceBanner": {
    "titleKey": "Manutenzione programmata",
    "bodyKey": "Non sarà possibile pagare dalle ore 00:01 alle ore 03:00 del 18 luglio 2025.",
    "linkTextKey": "Maggiori informazioni"
  },
  "maintenancePage": {
    "title": "Stiamo lavorando per te",
    "subtitle": "pagoPa non è al momento disponibile a causa di una manutenzione programmata.",
    "closeButton": "Chiudi",
    "detailsButton": "Scopri di più"
  }
}